import * as React from "react";
import * as Comp from "../../../../components";
import * as M from "../../../../models";

interface OwnProps {
    days: M.Search.SearchFilter[];
    loadingEvent: boolean;
    onFilterSelect: (id: string | number, checked: boolean, type: FilterType) => void;
}

interface OwnState {
}

export type FilterType = "day";

export class Filters extends React.Component<OwnProps, OwnState> {
    public render() {

        const loading = this.props.loadingEvent
            ? <><Comp.Generic.LoadingIcon /> Loading&hellip;</>
            : null;

        const filters = this.props.loadingEvent
            ? null
            : <>
                <Comp.Search.SearchFilterCategory
                    defaultSort="id"
                    filters={this.props.days}
                    onChange={(id, checked) => this.props.onFilterSelect(id, checked, "day")}
                    showAll
                    title="Jump to"
                />
            </>;

        return <div className="results-filters">
            {loading}
            {filters}
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminEvent/editCalendar/components/Filters.tsx